// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"4535":"login","6648":"dataCenter","6725":"H5ReportDetail"}[chunkId] || chunkId) + "." + __webpack_require__.h() + ".css";
};